export default {
    NZ	:0.0687,
    NO	:0.0436,
    AU	:0.0413,
    SE	:0.0359,
    FI	:0.0334,
    DK	:0.0314,
    CH	:0.0297,
    US	:0.0297,
    CA	:0.0246,
    EE	:0.0238,
    IE	:0.0227,
    LU	:0.0225,
    IS	:0.0220,
    SI	:0.0214,
    AT	:0.0207,
    GB	:0.0202,
    LV	:0.0197,
    RU	:0.0195,
    NL	:0.0180,
    BE	:0.0179,
    ZA	:0.0172,
    DE	:0.0152,
    FR	:0.0149,
    SG	:0.0144,
    CZ	:0.0131,
    KE	:0.0129,
    KZ	:0.0122,
    SA	:0.0122,
    ES	:0.0121,
    BY	:0.0115,
    UA	:0.0114,
    ZM	:0.0113,
    LT	:0.0107,
    GH	:0.0104,
    MQ	:0.0104,
    PL	:0.0104,
    MY	:0.0103,
    RE	:0.0103,
    OM	:0.0102,
    CI	:0.0101,
    SK	:0.0101,
    IT	:0.0100,
    MD	:0.0099,
    HK	:0.0098,
    JP	:0.0098,
    AE	:0.0097,
    HR	:0.0097,
    PT	:0.0095,
    AS	:0.0094,
    BG	:0.0089,
    GP	:0.0088,
    UZ	:0.0088,
    NG	:0.0087,
    CL	:0.0084,
    HU	:0.0084,
    RO	:0.0081,
    BH	:0.0079,
    UG	:0.0078,
    PR	:0.0076,
    TH	:0.0076,
    QA	:0.0070,
    GR	:0.0068,
    KW	:0.0067,
    MX	:0.0066,
    CM	:0.0064,
    IL	:0.0059,
    RS	:0.0059,
    TW	:0.0058,
    VN	:0.0058,
    GE	:0.0057,
    CY	:0.0056,
    YT	:0.0050,
    AM	:0.0049,
    MK	:0.0049,
    SN	:0.0049,
    TZ	:0.0047,
    CN	:0.0045,
    GF	:0.0045,
    CR	:0.0044,
    CD	:0.0042,
    KR	:0.0041,
    UY	:0.0041,
    CG	:0.0040,
    KG	:0.0040,
    ID	:0.0036,
    PE	:0.0036,
    CO	:0.0035,
    BA	:0.0033,
    MW	:0.0033,
    MZ	:0.0033,
    VI	:0.0033,
    AZ	:0.0032,
    MA	:0.0032,
    TN	:0.0032,
    AR	:0.0031,
    TM	:0.0031,
    IR	:0.0030,
    PG	:0.0030,
    PH	:0.0030,
    LB	:0.0029,
    PA	:0.0029,
    BR	:0.0028,
    EC	:0.0027,
    MT	:0.0027,
    TJ	:0.0027,
    GT	:0.0026,
    KH	:0.0026,
    NA	:0.0026,
    TR	:0.0025,
    LK	:0.0024,
    NI	:0.0024,
    MM	:0.0023,
    HN	:0.0021,
    PS	:0.0021,
    TT	:0.0021,
    BS	:0.0020,
    IN	:0.0020,
    NC	:0.0020,
    PY	:0.0020,
    RW	:0.0020,
    SV	:0.0020,
    BF	:0.0019,
    GN	:0.0019,
    ME	:0.0019,
    ML	:0.0019,
    JM	:0.0018,
    CW	:0.0017,
    SS	:0.0017,
    AF	:0.0016,
    BO	:0.0016,
    SD	:0.0016,
    AO	:0.0015,
    YE	:0.0015,
    JO	:0.0014,
    SY	:0.0014,
    TL	:0.0014,
    BW	:0.0013,
    DO	:0.0013,
    IQ	:0.0013,
    LC	:0.0013,
    PK	:0.0013,
    SO	:0.0013,
    EG	:0.0012,
    ET	:0.0012,
    MU	:0.0012,
    TD	:0.0012,
    DZ	:0.0011,
    LY	:0.0011,
    PF	:0.0011,
    ZW	:0.0011,
    AL	:0.0010,
    FJ	:0.0010,
    GU	:0.0010,
    HT	:0.0010,
    MV	:0.0010,
    NP	:0.0010,
    VE	:0.0010,
    BM	:0.0009,
    SZ	:0.0009,
    BN	:0.0008,
    BZ	:0.0008,
    CU	:0.0008,
    GY	:0.0008,
    KY	:0.0008,
    SL	:0.0008,
    VG	:0.0008,
    BB	:0.0007,
    BD	:0.0007,
    GM	:0.0007,
    MN	:0.0007,
    CF	:0.0006,
    CV	:0.0006,
    LA	:0.0006,
    SC	:0.0006,
    AG	:0.0005,
    BJ	:0.0004,
    GA	:0.0004,
    MO	:0.0004,
    MR	:0.0004,
    BI	:0.0003,
    BT	:0.0003,
    DM	:0.0003,
    LR	:0.0003,
    LS	:0.0003,
    VU	:0.0003,
    SR	:0.0001,
    AD	:0.0000,
    AI	:0.0000,
    AQ	:0.0000,
    AW	:0.0000,
    AX	:0.0000,
    BL	:0.0000,
    BQ	:0.0000,
    BV	:0.0000,
    CC	:0.0000,
    CK	:0.0000,
    CX	:0.0000,
    DJ	:0.0000,
    EH	:0.0000,
    ER	:0.0000,
    FK	:0.0000,
    FM	:0.0000,
    FO	:0.0000,
    GD	:0.0000,
    GG	:0.0000,
    GI	:0.0000,
    GL	:0.0000,
    GQ	:0.0000,
    GS	:0.0000,
    GW	:0.0000,
    HM	:0.0000,
    IM	:0.0000,
    IO	:0.0000,
    JE	:0.0000,
    KI	:0.0000,
    KM	:0.0000,
    KN	:0.0000,
    KP	:0.0000,
    LI	:0.0000,
    MC	:0.0000,
    MF	:0.0000,
    MG	:0.0000,
    MH	:0.0000,
    MP	:0.0000,
    MS	:0.0000,
    NE	:0.0000,
    NF	:0.0000,
    NR	:0.0000,
    NU	:0.0000,
    PM	:0.0000,
    PN	:0.0000,
    PW	:0.0000,
    SB	:0.0000,
    SH	:0.0000,
    SJ	:0.0000,
    SM	:0.0000,
    ST	:0.0000,
    SX	:0.0000,
    TC	:0.0000,
    TF	:0.0000,
    TG	:0.0000,
    TK	:0.0000,
    TO	:0.0000,
    TV	:0.0000,
    UM	:0.0000,
    VA	:0.0000,
    VC	:0.0000,
    WF	:0.0000,
    WS	:0.0000
};


// WEBPACK FOOTER //
// ./src/scenes/ZeroPark/bid.config.js